/* Custom: plays product-card videos on hover.
   Pairs with the .card-hover-video overlay in snippets/product-media.liquid.
   Videos load nothing until the first hover (preload="none"), play muted and
   looped while the pointer is over the card, and rewind when it leaves. */
(() => {
  if (window.__cardHoverVideoInit) return;
  window.__cardHoverVideoInit = true;

  const isCardGallery = (target) =>
    target instanceof Element && target.classList.contains('card-gallery');

  document.addEventListener(
    'pointerenter',
    (event) => {
      if (event.pointerType === 'touch' || !isCardGallery(event.target)) return;
      for (const video of event.target.querySelectorAll('video.card-hover-video')) {
        if (video.dataset.hoverLoaded !== 'true') {
          video.dataset.hoverLoaded = 'true';
          video.preload = 'auto';
          video.load();
        }
        video.muted = true;
        const playing = video.play();
        if (playing) {
          playing.then(() => video.classList.add('is-playing')).catch(() => {});
        } else {
          video.classList.add('is-playing');
        }
      }
    },
    true
  );

  document.addEventListener(
    'pointerleave',
    (event) => {
      if (!isCardGallery(event.target)) return;
      for (const video of event.target.querySelectorAll('video.card-hover-video')) {
        video.pause();
        if (video.dataset.hoverLoaded === 'true') {
          try {
            video.currentTime = 0;
          } catch {
            /* metadata not ready yet — nothing to rewind */
          }
        }
        video.classList.remove('is-playing');
      }
    },
    true
  );
})();
